import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-add-consumer-goods',
  templateUrl: './add-consumer-goods.component.html',
  styleUrls: ['./add-consumer-goods.component.scss']
})
export class AddConsumerGoodsComponent {

  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  circlesList: any[] = [];
  consumerGoodsForm!: FormGroup;
  distributionForm!: FormGroup;
  rows: any[] = [];
  months: any[] = [];
  showButton=false
  currentMonth: any = {};
 columns = [
    { name: 'Sr.No' },
    { prop: 'financialYear', name: 'Financial Year' },
    { prop: 'dataMonth', name: 'Data Month' },
    { prop: 'urbanControlled', name: 'Urban Controlled' },
    { prop: 'urbanNonControlled', name: 'Urban Non-Controlled' },
    { prop: 'ruralControlled', name: 'Rural Controlled' },
    { prop: 'ruralNonControlled', name: 'Rural Non-Controlled' },
    { prop: 'isVerified', name: 'Verified' }
  ];

    monthKeyMap: Record<number, string> = {
    1: 'april',
  2: 'may',
  3: 'june',
  4: 'july',
  5: 'august',
  6: 'september',
  7: 'october',
  8: 'november',
  9: 'december',
  10: 'january',
  11: 'february',
  12: 'march'
    };
  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;

    const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"


         this.consumerGoodsForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }, Validators.required],
      dataMonth: [{ value: currentMonthYear, disabled: true }, Validators.required],

      urbanControlled: [0, [Validators.required, Validators.min(0)]],
      urbanUnControlled: [0, [Validators.required, Validators.min(0)]],
      ruralControlled: [0, [Validators.required, Validators.min(0)]],
      ruralUnControlled: [0, [Validators.required, Validators.min(0)]],
     
    });
   this.distributionForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }, Validators.required],
      dataMonth: [{ value: '', disabled: false }, Validators.required],
      urbanControlled: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      urbanNonControlled: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      ruralControlled: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      ruralNonControlled: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
    });
    // this.GetConsumerGoods();.
    this.getTargetCount();
    this.GetYearAndMonth();

         switch (this.UserDetails?.roleId) {
      case 13:
       
        break;
      case 1:
             this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
       this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();
        this.targetForm.get('blockOffice')?.valueChanges
          .pipe(skip(1)) // ignore the first emit
          .subscribe((val: any) => {
            if (this.targetForm.valid) {
              this.GetConsumerGoods();
            }
          });
    
        break;
      default:
    }
    this.targetForm.valueChanges
  .pipe(debounceTime(300))  // waits 300ms after last change
  .subscribe(values => {
    if (this.targetForm.valid) {
      this.GetConsumerGoods();
    }
  });
  }

   getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if(this.UserDetails?.roleId !== 1){
       this.blockList = res.data.blocks;
        }
 
          this.financialYears = res.data.financialYears
           if(this.UserDetails?.roleId ==11){
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
            this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {
  
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
        

    
      }
    },
      (error: any) => {
      }
    );
  }

   GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId":0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }
    
    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        
        this.blockList = res.data?.block;
          this.targetForm.controls['blockOffice'].setValue('');
    
      }
    },
      (error: any) => {
      }
    );
  }

  GetConsumerGoods() {
    let obj = {
         blockId: this.targetForm.getRawValue().blockOffice.toString(),
        "financialYear": this.targetForm.value?.financialYear?.financialYear
    }
    this.reportService.GetConsumerGoods(obj).subscribe((res: any) => {
      if (res && res?.data && res?.data.length > 0) {
            let lastRow = res?.data[res?.data.length - 1];
           
            this.rows =res?.data
            if (Number(lastRow?.dataMonth) != 12 && Number(lastRow?.dataMonth) < 12) {
                      let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
                 let year = (Number(lastRow?.dataMonth) <= 9)? fyear?.split('-')[0] :fyear.split('-')[1] 
              this.currentMonth.key = (Number(lastRow?.dataMonth) + 1).toString();
              this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.dataMonth) + 1)] + ', ' +year; 
              this.showButton = true
            } else {
              this.showButton = false
            }


          } else {
         this.rows = []
            this.showButton = true;
            this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
            this.currentMonth.key = '1';
              this.toastService.showInfo('NO Data Found!')
          }
    },
      (error: any) => {
      }
    );
  }
  // Map numeric month to name
getMonthName(month: string | number): string {
  const months = [
    'April', 'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December','January', 'February', 'March',
  ];
  const index = +month - 1;
  return months[index] || 'Unknown';
}

// Derive year from financial year string based on month
getYearFromFinancialYear(financialYear: string, month: string | number): string {
  const [startYear, endYear] = financialYear.split('-');
  const monthNum = +month;
  return monthNum >= 1 && monthNum <= 9 ? startYear : endYear;
}
 GetYearAndMonth() {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;


        // this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }
  addData(){
      this.distributionForm.patchValue({
  financialYear: this.targetForm.value?.financialYear,
  blockOffice: this.targetForm.getRawValue()?.blockOffice,
     dataMonth:this.currentMonth.key
});
  }
  

  onSubmit() {
    if (this.distributionForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const payload = this.distributionForm.getRawValue();
      // let entryYear = this.reportingYears.find((i) => i?.startYear == payload?.offilneEntryYear)
      let obj = {
      
        
  "blockId":  Number(payload?.blockOffice),
  "financialYear":  payload?.financialYear?.financialYear?.toString(),
  "dataMonth": payload?.dataMonth,
  "urbanControlled":Number( payload?.urbanControlled),
  "urbanNonControlled":Number( payload?.urbanNonControlled),
  "ruralControlled":Number( payload?.ruralControlled),
  "ruralNonControlled":Number( payload?.ruralNonControlled),
      "createdBy":  this.edit ?0:this.UserDetails?.id,
        "modifiedBy": this.edit ?this.UserDetails?.id:0,
        id:this.edit ? this.editId:0
   
      }

      this.reportService.addConsumerGoods(obj).subscribe((res: any) => {
        if (res) {
          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('ConsumerGoodsDistributionDataModal');
            this.distributionForm.reset();
            this.distributionForm.markAsUntouched();
            this.GetConsumerGoods();
             this.edit =false
             this.editId = 0;
          }else{
            this.toastService.showError(res.message);
          }

        }
       
      },
        (error: any) => {
        }
      );


    } else {
      this.distributionForm.markAllAsTouched();
    }
  }

  edit= false;
  editId=0


    openModal(model: any) {
      const modalElement = document.getElementById(model);
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
        modalInstance.show();
  
      }
    }
  
    hideModal(model: any) {
      const modalElement = document.getElementById(model);
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
        modalInstance.hide();
      }
    }

      editRow(row: any) {

    const patchData = row;
    const headerData = this.targetForm.getRawValue();
   let year = this.financialYears.find((i)=>i?.financialYear == row?.financialYear)
this.distributionForm.patchValue({
  financialYear:  headerData.financialYear,
  blockOffice:Number(headerData?.blockOffice),
  dataMonth: patchData.dataMonth,
  urbanControlled: patchData.urbanControlled,
  urbanNonControlled: patchData.urbanNonControlled,
  ruralControlled: patchData.ruralControlled,
  ruralNonControlled: patchData.ruralNonControlled
});


this.editId = patchData?.id
this.edit =true

    this.openModal('ConsumerGoodsDistributionDataModal');
  }

    DeleteConsumerData(id:any){
     this.reportService.DeleteConsumerData(id).subscribe((res:any) => {
      if (res) {
   if(res?.status ==200){
    this.toastService.showSuccess(res.message);
    this.deleteIndex = 0;
    // this.hideModal();
     this.GetConsumerGoods();
   }
   
      }
    },
      (error: any) => {
      }
    );
  }
closeModel(){
  this.distributionForm.reset()
  this.distributionForm.markAsUntouched()
  this.editId = 0
this.edit =false
}
    verifyConsumerData(id:any){
     this.reportService.verifyConsumerData(id).subscribe((res:any) => {
      if (res) {
   if(res?.status ==200){
    this.toastService.showSuccess(res.message);
     this.deleteIndex = 0;
    // this.hideModal();
     this.GetConsumerGoods();
   }
   
      }
    },
      (error: any) => {
      }
    );
  }
           deleteIndex:any
 setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete(){
   this.deleteIndex = 0;

  }
}
